import { useParams } from 'react-router-dom'
import { HMSPrebuilt } from '@100mslive/roomkit-react'
import { decodeInterviewToken } from '../utilities/tokenUtils'

function InPersonInterview() {
  const { interviewToken } = useParams()
  const decodedToken = decodeInterviewToken(interviewToken)
  const roomCode = decodedToken.room_code

  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <HMSPrebuilt roomCode={roomCode} />
    </div>
  )
}

export default InPersonInterview
